import KeyboardArrowDownOutlinedIcon from '@mui/icons-material/KeyboardArrowDownOutlined'
import LanguageIcon from '@mui/icons-material/Language'
import {CircularProgress, Link, Theme} from '@mui/material'
import {makeStyles} from 'tss-react/mui'

type MobileLanguageSelectorProps = {
  languageName?: string
  languageLoading: boolean
  onOpenPicker: () => void
}

const MobileLanguageSelector = ({
  languageName,
  languageLoading,
  onOpenPicker,
}: MobileLanguageSelectorProps) => {
  const {classes} = useStyles()

  return (
    <li>
      <Link
        component='button'
        color='textPrimary'
        className={classes.actionItem}
        onClick={() => {
          if (!languageLoading) {
            onOpenPicker()
          }
        }}
      >
        {languageLoading ? (
          <CircularProgress size={20} sx={{color: 'primary.main'}} />
        ) : (
          <LanguageIcon className={classes.actionIcon} />
        )}
        <span className={classes.label}>{languageName}</span>
        <KeyboardArrowDownOutlinedIcon className={classes.chevron} />
      </Link>
    </li>
  )
}

export default MobileLanguageSelector

const useStyles = makeStyles()((theme: Theme) => ({
  actionItem: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
    width: '100%',
    minHeight: 44,
    padding: theme.spacing(2),
    fontSize: 16,
    textAlign: 'left',
    textDecoration: 'none',
    color: theme.palette.text.primary,
    boxSizing: 'border-box',
  },
  actionIcon: {
    fontSize: 20,
    color: theme.palette.text.primary,
  },
  label: {
    flexGrow: 1,
  },
  chevron: {
    fontSize: 20,
    color: theme.palette.text.primary,
  },
}))
